import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_MEMBERS_AND_CASE_DOCUMENTS_REQUEST: '',
  GET_MEMBERS_AND_CASE_DOCUMENTS_SUCCESS: '',
  GET_MEMBERS_AND_CASE_DOCUMENTS_FAILURE: '',

  GET_CASE_DOCUMENT_REQUEST: '',
  GET_CASE_DOCUMENT_SUCCESS: '',
  GET_CASE_DOCUMENT_FAILURE: '',

  GET_CASE_LETTER_INFO_REQUEST: '',
  GET_CASE_LETTER_INFO_SUCCESS: '',
  GET_CASE_LETTER_INFO_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityCaseDoc');

export default types;
